// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pageBody":"pageBody-3QbrdJlo","content_list":"content_list-2DvfBC3R","chip_item":"chip_item-3ZqsagXa"};